var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-toggle clickable",class:{'disable': _vm.disable},on:{"click":_vm.chooseThis}},[_c('el-tag',{attrs:{"type":_vm.computedType,"effect":_vm.effect}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }